module.exports = __webpack_public_path__ + "img/KAZ.bb118da4.svg";